import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import * as moment from 'moment';

@Component({
  selector: 'app-profile-tab',
  templateUrl: './profile-tab.component.html',
  styleUrls: ['./profile-tab.component.scss']
})
export class ProfileTabComponent implements OnInit {

  @Input() skillsData: any[] = [];
  @Input() basicDetails: any;
  @Input() experienceDetails: any;
  @Input() educationDetails: any;
  @Input() isCurrentUserTheCreator: any;
  currentCompanyInformation = {};
  @Output() childEvents = new EventEmitter<{ action: string, data?: any }>();
  formattedSkills: any[] = [];
  @Input() interestDetails: any[] = [];

  constructor(private personSearchService: PersonSearchService) { }

  ngOnInit(): void {
    this.formatSkills('less');
    this.experienceDetails = this.experienceDetails.map(obj => {
      const startDate = obj.startdate ? moment(obj.startdate) : null;
      const endDate = moment(obj.enddate || new Date());
      const totalTenure = endDate.diff(startDate, 'years', true);
      obj.totaltenure = this.getFormattedTenure(totalTenure);
      return obj;
    });
  }

  openUrl(link, type) {
    if (!link || !type)
      return;
    if (link.startsWith("www.linkedin") || link.startsWith("www.facebook") || link.startsWith("www.twitter") || link.startsWith("www.github"))
      link = "https://" + link;
    else if (type == 'linkedin' && !(link.includes("https://www.linkedin") || link.includes("https://linkedin") || link.includes("https://in.linkedin") || link.includes("http://linkedin") || link.includes("http://www.linkedin")))
      link = "https://www." + link;
    else if (type == 'facebook' && !(link.includes("https://www.facebook") || link.includes("https://facebook") || link.includes("https://in.facebook") || link.includes("http://facebook") || link.includes("http://www.facebook")))
      link = "https://www." + link;
    else if (type == 'twitter' && !(link.includes("https://www.twitter") || link.includes("https://twitter") || link.includes("https://in.twitter") || link.includes("http://twitter") || link.includes("http://www.twitter")))
      link = "https://www." + link;
    else if (type == 'github' && !(link.includes("https://www.github") || link.includes("https://github") || link.includes("https://in.github") || link.includes("http://github") || link.includes("http://www.github")))
      link = "https://www." + link;
      else if (type == 'website'){
        link = "https://www." + link;
      }
    window.open(link, "_blank")
  }

  getCompanyInfo(data: any){
    if(data && !data.website){
      return
    }
    this.currentCompanyInformation = {}
    let companyData = {
      companynames:[data.companyname]
    }
    
    this.personSearchService.getCompanyLogo(companyData).subscribe((res: any) => {
      if(res.status == 'success' && res.message){
        let companyDetails = res.message[0]
        this.currentCompanyInformation['companylogo'] = companyDetails.companylogo
        this.currentCompanyInformation['name'] = companyDetails.name ? companyDetails.name : data.companyname
        this.currentCompanyInformation['industry'] = companyDetails.industry
        this.currentCompanyInformation['location'] = companyDetails?.location?.name
        this.currentCompanyInformation['size'] = companyDetails.size
        this.currentCompanyInformation['linkedin_url'] = companyDetails.linkedin_url
        this.currentCompanyInformation['website'] = companyDetails.website ? companyDetails.website : data.website
        this.currentCompanyInformation['tags'] = companyDetails.tags        
        this.currentCompanyInformation['id'] = companyDetails.id  
        this.currentCompanyInformation['key_id'] = res.message[0].id  
      }
    });
  
  }

  redirecttolinkedin() {
    let linkedin = this.basicDetails.profileurl
    const downloadLink = document.createElement("a");
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.setAttribute("href", linkedin);
    downloadLink.setAttribute("target", "_blank")
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  handleAction(action: string, data?: any) {
    this.childEvents.emit({ action, data });
  }

  formatSkills(type) {
    this.formattedSkills = type == 'more' ? this.skillsData : this.skillsData.slice(0, 5);
  }

  private getFormattedTenure(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if (totalYears > 0 && totalMonths > 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'} ${totalMonths} Mths`;
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      return `${totalMonths} Mths`;
    } else {
      return '';
    }
  }
}
